(function () {

  /* ==========================
     LANGUE ACTIVE
  ========================== */
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);

  /* ==========================
     TEXTES TXT / PDF
  ========================== */
  const TXT_TXT = {
    fr: {
      title: "Routine personnalisée",
      machine: "Machine",
      rule: "Règle appliquée",
      cycle1: "Cycle 1 – Lavage coton ou mixte ≥30 min · 30°C",
      cycle2: "Cycle 2 – Lavage coton ≥1h30 · 40°C",
      swoosh: "⚠️ Swoosh positif : réduire la dose ou ajouter des rinçages",
      water: "Consommation d’eau",
      waterReco: "Consommation d’eau recommandée"
    },

    en: {
      title: "Personalized washing routine",
      machine: "Machine",
      rule: "Applied rule",
      cycle1: "Cycle 1 – Cotton or mixed wash ≥30 min · 30°C",
      cycle2: "Cycle 2 – Cotton wash ≥1h30 · 40°C",
      swoosh: "⚠️ Positive swoosh: reduce dosage or add rinses",
      water: "Water consumption",
      waterReco: "Recommended water consumption"
    },

    de: {
      title: "Personalisierte Waschroutine",
      machine: "Maschine",
      rule: "Angewandte Regel",
      cycle1: "Zyklus 1 – Baumwolle oder Mischwäsche ≥30 Min · 30°C",
      cycle2: "Zyklus 2 – Baumwollwäsche ≥1h30 · 40°C",
      swoosh: "⚠️ Positiver Swoosh-Test: Dosierung senken oder Spülgänge hinzufügen",
      water: "Wasserverbrauch",
      waterReco: "Empfohlener Wasserverbrauch"
    }
  };

  const TTXT = TXT_TXT[lang] || TXT_TXT.fr;

  /* ==========================
     ROOT
  ========================== */

  const root = document.getElementById('mbdcRoutine');
  if (!root) return;

  const $ = (s) => root.querySelector(s);
  let lastResult = null;

  function fmt(n){ return Math.round(Number(n || 0)); }

  /* ==========================
     CALCUL
  ========================== */

  function compute(){

    const capKg = parseFloat($('#mbdc-capKg')?.value || 7);
    let waterText = "";

    if (capKg <= 7) {
      waterText = "50 L pour une machine de 4 à 7 kg";
    } else if (capKg <= 9) {
      waterText = "60 L pour une machine de 7 à 9 kg";
    } else {
      waterText = "70 L pour une machine de 9 à 15 kg";
    }

    const hard  = $('#mbdc-hard')?.value;

    if (!hard){
      $('#mbdc-out').innerHTML = `
        <div class="warn">
          <strong>⚠️ ${TTXT.title}</strong><br>
          ${
            lang === 'en'
              ? 'Please select your water hardness before generating the routine.'
              : lang === 'de'
                ? 'Bitte wählen Sie Ihre Wasserhärte, bevor Sie die Routine erstellen.'
                : 'Veuillez sélectionner la dureté de votre eau avant de générer la routine.'
          }
        </div>
      `;
      return;
    }

    const doseLabel = parseFloat($('#mbdc-doseLabel')?.value || 110);
    const swoosh = $('#mbdc-swooshPos')?.checked || false;

    let adjustedDose = doseLabel;
    let ruleText = "7–10 kg";

    if (capKg < 7){
      adjustedDose -= 30;
      ruleText = "< 7 kg → −30 ml";
    } 
    else if (capKg >= 11 && capKg <= 14){
      adjustedDose *= (7 / 4.5);
      ruleText = "11–14 kg";
    } 
    else if (capKg >= 15){
      adjustedDose *= (8 / 4.5);
      ruleText = "≥ 15 kg";
    }

    const preDose = adjustedDose / 3;
    const mainDose = adjustedDose;

    lastResult = { capKg, ruleText, preDose, mainDose, swoosh };

    $('#mbdc-out').innerHTML = `

      <div class="card">

        <h2>${TTXT.title}</h2>

        <div class="kpis">

          <div class="kpi">
            <div>${TTXT.machine}</div>
            <strong>${fmt(capKg)} kg</strong>
          </div>

          <div class="kpi">
            <div>${TTXT.rule}</div>
            <strong>${ruleText}</strong>
          </div>

          <div class="kpi">
            <div>${TTXT.water}</div>
            <strong>${waterText}</strong>
          </div>

        </div>

        <div class="water-estimate">
          <div class="water-title">${TTXT.waterReco}</div>
          <div class="water-value">${waterText}</div>
        </div>

        <div class="grid-2">

          <div class="cycle-card">
            <div class="cycle-title">${TTXT.cycle1}</div>

            <div class="cycle-meta">
              <span class="cycle-badge">≥ 30 min</span>
              <span class="cycle-badge">30 °C</span>
            </div>

            <div class="cycle-dose">${fmt(preDose)} ml</div>
          </div>

          <div class="cycle-card">
            <div class="cycle-title">${TTXT.cycle2}</div>

            <div class="cycle-meta">
              <span class="cycle-badge">≥ 1h30</span>
              <span class="cycle-badge">40 °C</span>
            </div>

            <div class="cycle-dose">${fmt(mainDose)} ml</div>
          </div>

        </div>

        ${swoosh ? `<p><strong>${TTXT.swoosh}</strong></p>` : ``}

      </div>
    `;

    $('#mbdc-btnPrint').disabled = false;
  }

  /* ==========================
     PDF
  ========================== */

function printRoutine(){

  const src = document.querySelector('#mbdc-printArea') 
           || document.querySelector('#mbdc-out');

  if(!src) return;

  const html = `
<!doctype html>
<html lang="${lang}">
<head>

<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title>${TTXT.title}</title>

<style>

body{
font-family:"Fira Sans",Arial,sans-serif;
background:#ffffff;
padding:30px;
color:#5c5c5c;
min-width:700px;
}

@page{
size:A4;
margin:20mm;
}

/* largeur PDF */
.wrapper{
max-width:720px;
margin:auto;
width:100%;
}

/* titre */
h2{
font-family:"Nunito",Arial,sans-serif;
color:#0f7d80;
font-weight:800;
margin-bottom:20px;
}

/* carte */
.card{
background:linear-gradient(180deg,#ffffff,#f2faff);
border:1px solid rgba(15,125,128,.18);
border-radius:20px;
padding:20px;
}

/* KPI */
.kpis{
display:flex;
gap:12px;
margin-bottom:20px;
}

.kpi{
flex:1;
background:#f7fbfb;
border:1px solid rgba(15,125,128,.16);
border-radius:14px;
padding:10px;
text-align:center;
}

.kpi div{
font-size:12px;
color:#6b7280;
}

.kpi strong{
color:#0f7d80;
font-weight:800;
}

/* cycles */
.grid-2{
display:flex;
flex-wrap:wrap;
gap:14px;
}

.cycle-card{
flex:1 1 48%;
min-width:260px;
background:#ffffff;
border:1px solid rgba(15,125,128,.18);
border-radius:16px;
padding:16px;
}

.cycle-title{
color:#0f7d80;
font-weight:800;
margin-bottom:6px;
}

.cycle-meta{
margin-bottom:8px;
}

.cycle-badge{
font-size:11px;
padding:4px 8px;
border-radius:999px;
background:#eef8f7;
border:1px solid rgba(15,125,128,.18);
margin-right:6px;
}

.cycle-dose{
font-size:20px;
font-weight:800;
color:#0f7d80;
}

.footer{
margin-top:30px;
font-size:12px;
color:#888;
text-align:center;
}

</style>

</head>

<body>

<div class="wrapper">

${src.innerHTML}

<div class="footer">
Routine générée automatiquement • Ma Boule de Couches
</div>

</div>

<script>
window.onload = function(){
  setTimeout(function(){
    window.print();
  },400);
}
<\/script>

</body>
</html>
`;

const win = window.open("", "_blank");

if(!win){
  alert("Veuillez autoriser les popups pour générer le PDF.");
  return;
}

win.focus();   // ← AJOUT ICI

win.document.open();
win.document.write(html);
win.document.close();
}

  /* ==========================
     CONVERTER
  ========================== */

  function initConverter(){

    const gramsEl = root.querySelector('#conv-grams');
    const densityEl = root.querySelector('#conv-density');
    const mlEl = root.querySelector('#conv-ml');

    if (!gramsEl || !densityEl || !mlEl) return;

    const num = (v)=>{
      const n=parseFloat(String(v).replace(',','.'));
      return Number.isFinite(n)?n:0;
    };

    let lock=false;

    function toML(){

      if(lock)return;
      lock=true;

      const g=num(gramsEl.value);
      const d=Math.max(0.01,num(densityEl.value));

      mlEl.value=Math.round((g/d)*10)/10;

      lock=false;
    }

    function toG(){

      if(lock)return;
      lock=true;

      const ml=num(mlEl.value);
      const d=Math.max(0.01,num(densityEl.value));

      gramsEl.value=Math.round((ml*d)*10)/10;

      lock=false;
    }

    gramsEl.addEventListener('input',toML);
    mlEl.addEventListener('input',toG);

    densityEl.addEventListener('input',()=>{

      if(num(gramsEl.value)>0) toML();
      else toG();

    });

    toML();
  }

/* ==========================
   INIT
========================== */

function init(){

  $('#mbdc-run')?.addEventListener('click',compute);

  $('#mbdc-btnPrint')?.addEventListener('click',printRoutine);

  initConverter();
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded',init)
  : init();

})();